import { apiSlice } from '../apiSlice'

export const orderApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    placeOrder: builder.mutation({
      query: (data) => ({
        url: '/orders/place-order',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: () => [
        { type: 'orders' },
        { type: 'salesSummary' },
        { type: 'currentCapital' },
      ],
    }),

    getOrders: builder.query({
      query: ({
        page,
        size,
        reference,
        createdBy,
        companyName,
        orderType,
        status,
        from,
        to,
      }) =>
        `/orders?pageNo=${page}&pageSize=${size}&reference=${reference}&createdBy=${createdBy}&companyName=${companyName}&orderType=${orderType}&paymentStatus=${status}&from=${from}&to=${to}`,

      keepUnusedDataFor: 600,
      providesTags: (result) => {
        if (result?.content && Array.isArray(result.content)) {
          return [
            {
              type: 'orders',
            },
            ...result.content.map(({ id }) => ({ type: 'order', id })),
          ]
        }
        return [{ type: 'orders' }]
      },
    }),
    getOrderById: builder.query({
      query: (orderId) => `/orders/order/${orderId}`,
      providesTags: (result, error, orderId) => [
        { type: 'order', id: orderId },
      ],
    }),
    addPayment: builder.mutation({
      query: ({ data, orderId }) => ({
        url: `/orders/add-payment/${orderId}`,
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
        },
        body: data,
      }),
      invalidatesTags: (result, error, { orderId }) => [
        { type: 'order', id: orderId },
        { type: 'salesSummary' },
        { type: 'currentCapital' },
      ],
    }),
    downloadInvoice: builder.query({
      query: (orderId) => ({
        url: `/orders/order/${orderId}/invoice`,
        method: 'GET',
      }),
    }),
    updateDeliveryStatus: builder.mutation({
      query: ({ orderId, status }) => ({
        url: `/orders/order/delivery-status/${orderId}`,
        method: 'POST',
        headers: {
          'Content-type': 'application/json',
        },
        body: JSON.stringify({ deliveryStatus: status }),
      }),
      invalidatesTags: (result, error, { orderId }) => [
        { type: 'order', id: orderId },
      ],
    }),
  }),
})

export const {
  useGetOrdersQuery,
  usePlaceOrderMutation,
  useGetOrderByIdQuery,
  useAddPaymentMutation,
  useUpdateDeliveryStatusMutation,
  useLazyDownloadInvoiceQuery,
} = orderApi
